import { element, showMessage } from './publicUi.js';

export class FeedbackForm {
  constructor({ send, keyFactory = () => crypto.randomUUID() }) { this.send = send; this.keyFactory = keyFactory; this.fields = {}; }
  render() {
    const form = element('form', 'post-editor'); this.form = form;
    for (const [name, label, tag, max] of [['sender', 'Имя, email или другой контакт', 'input', 254], ['subject', 'Тема', 'input', 200], ['message', 'Сообщение', 'textarea', 10000]]) {
      const field = element(tag, 'auth-input'); field.name = name; field.maxLength = max; field.required = true;
      if (tag === 'textarea') field.rows = 7;
      const caption = element('label', 'auth-form-label', label); caption.append(field); form.append(caption); this.fields[name] = field;
    }
    this.fields.website = element('input'); this.fields.website.type = 'text'; this.fields.website.name = 'website'; this.fields.website.maxLength = 200;
    this.fields.website.autocomplete = 'off'; this.fields.website.tabIndex = -1; this.fields.website.hidden = true; this.fields.website.setAttribute('aria-hidden', 'true');
    form.append(this.fields.website);
    this.submitButton = element('button', 'filter-btn', 'Отправить сообщение');
    this.feedback = element('div'); this.feedback.setAttribute('role', 'status'); this.feedback.setAttribute('aria-live', 'polite');
    form.append(this.submitButton, this.feedback);
    form.addEventListener('submit', event => { event.preventDefault(); void this.submit(); }); return form;
  }
  payload() { return Object.fromEntries(Object.entries(this.fields).map(([name, field]) => [name, field.value])); }
  async submit() {
    if (this.busy || this.completed || this.disposed) return;
    const data = this.payload();
    if (!data.sender.trim() || !data.subject.trim() || !data.message.trim()
      || data.sender.length > 254 || data.subject.length > 200 || data.message.length > 10000 || data.website.length > 200
      || data.sender.includes('\0') || data.subject.includes('\0') || data.message.includes('\0')
      || (data.sender.includes('@') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.sender))) {
      showMessage(this.feedback, 'Заполните контакт, тему и сообщение; проверьте длину полей и адрес email.'); return;
    }
    const snapshot = JSON.stringify(data);
    if (!this.key || this.snapshot !== snapshot) { this.key = this.keyFactory(); this.snapshot = snapshot; }
    this.busy = true; const controls = [...this.form.querySelectorAll('input,textarea,button')]; controls.forEach(control => { control.disabled = true; });
    showMessage(this.feedback, 'Отправка сообщения…');
    try {
      await this.send(data, this.key); this.completed = true;
      if (!this.disposed) {
        for (const field of Object.values(this.fields)) field.value = '';
        this.key = this.snapshot = null; showMessage(this.feedback, 'Сообщение принято. Оно появилось во входящих администратора.');
      }
    } catch (error) {
      if (!this.disposed) {
        if (error.code === 'IDEMPOTENCY_CONFLICT') this.key = this.snapshot = null;
        showMessage(this.feedback, error.message);
      }
    } finally {
      this.busy = false;
      if (!this.disposed) controls.forEach(control => { control.disabled = !!this.completed; });
    }
  }
  dispose() {
    this.disposed = true; this.key = this.snapshot = null;
    for (const field of Object.values(this.fields)) field.value = '';
  }
}
